


































































































































import uuid from 'uuid/v4';
import Draggable from 'vuedraggable';
import { GridColumn, GridTable } from '@/components/grid';
import FieldBase from '@/components/field/Base.vue';
import InfoBox from '@/components/InfoBox.vue';
import ShowGuide from '@/components/ShowGuide.vue';
import { IProductResource, IProductMaterialDetail } from '@/services/product';
import materialUnits from '@/services/material/units';

interface IGenericKeyValue {
  [key: string]: string;
}

const firstMaterialUnit = Object.keys(materialUnits)[0];
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      materialUnits,
      isMobile: this.$store.state.isMobile,
      rowShape: () => ({
        // `index` set by localValue setter
        // `resource_id` set by dropdown
        id: uuid(),
        name: '',
        qty: 1,
        unit: firstMaterialUnit,
      }),
    };
  },
  computed: {
    localValue: {
      get(): Array<IProductResource<any>> {
        return this.value;
      },
      set(value: Array<IProductResource<any>>) {
        // set material index
        this.$emit('input', (
          value.map((material, index) => ({
            ...material,
            index,
          }))
        ));
      },
    },
    resourceList() {
      return this.list.reduce((
        list: IGenericKeyValue,
        resource: IProductResource<any>,
      ) => {
        list[resource.id] = resource.name;
        return list;
      }, {});
    },
  },
  methods: {
    concatProps(material: IProductMaterialDetail) {
      const props = [];
      material.color
        && props.push(material.color);
      material.composition
        && props.push(material.composition);
      material.weight
        && props.push(material.weight + 'gsm');
      return props.join(' · ');
    },
    selected(resourceId: string, row: { index: number, data: IProductResource<any> }) {
      this.$set(this.localValue, [row.index], {
        ...this.localValue[row.index],
        resource_id: resourceId,
        detail: (this.list as any).find((resource: IProductResource<any>) => {
          return resource.id === row.data.resource_id;
        }),
      });
      this.$emit('select', row);
    },
  },
  components: {
    Draggable,
    FieldBase,
    GridColumn,
    GridTable,
    InfoBox,
    ShowGuide,
  },
} as IView;
